import { withPublicAssetUrl } from '../../../lib/utils/cdn'

export const GrammarCheckIcon = () => (
  <img src={withPublicAssetUrl('tools-secondary-nav/grammar-checker.svg')} width="24" height="24" alt="" />
)

export const PlagiarismCheckerIcon = () => (
  <img src={withPublicAssetUrl('tools-secondary-nav/plagiarism-checker-icon.svg')} width="16.5" height="13.5" alt="" />
)

export const ParaphrasingToolIcon = () => (
  <img src={withPublicAssetUrl('tools-secondary-nav/paraphraser-icon.svg')} width="24" height="24" alt="" />
)

export const AiDetectorIcon = () => (
  <img src={withPublicAssetUrl('tools-secondary-nav/ai-detector-icon.svg')} width="24" height="24" alt="" />
)

export const AiHumanizerIcon = () => (
  <img src={withPublicAssetUrl('tools-secondary-nav/humanizer-icon.svg')} width="19.2" height="19.2" alt="" />
)
